import { render, staticRenderFns } from "./RegistriesAndServicesCompose.vue?vue&type=template&id=27dd2334"
import script from "./RegistriesAndServicesCompose.vue?vue&type=script&lang=js"
export * from "./RegistriesAndServicesCompose.vue?vue&type=script&lang=js"
import style0 from "./RegistriesAndServicesCompose.vue?vue&type=style&index=0&id=27dd2334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports